import React from 'react'
import DefaultButton from '../../components/DefaultButton'

export default function NotFound() {
  return (
    <>
      <section className='notfound header-gap'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='notfound-main text-center'>
                <img src='/assets/images/404-img.webp' alt='Not Found' />
                <h1>We couldn’t find the page you’re looking for.</h1>
                <p>It may have moved, or no longer exists. Let’s get you back on track.</p>
                <DefaultButton text={"GO TO HOMEPAGE"} to={"/"} color={true} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
